// The menu's choice rules every surface must agree on (F-FNB-01, F-FNB-04), with **no imports at all**, so the
// consoles can take them without pulling `@clavian/contracts`' schema runtime into a page under a strict CSP
// (`@clavian/domain/menu-choice`). The server's refusal and a surface's disabled Add button decide the same.
//
//  1. **Modifier groups** (spec/13 §6.1). A group asks for between `minChoices` and `maxChoices` of its
//     modifiers; a `required` group asks for at least one even when its `minChoices` is 0. A choice counts once
//     per time it is named.
//  2. **The order number** (spec/13 §6.2) reads `#0421`: at least four digits, zero-padded, so it is called out
//     the same way on the ticket, the kiosk tracker and Orders.
/** The least number of choices a group accepts: its `minChoices`, and at least 1 when it is required. */
export function modifierGroupMinimum(group) {
    return Math.max(group.minChoices, group.required ? 1 : 0);
}
/**
 * The first group the chosen modifiers do not satisfy, in the groups' order, or `null` when every group is
 * satisfied. A chosen id that belongs to no group is not this rule's concern (the caller refuses an unknown
 * modifier by itself).
 */
export function modifierChoiceProblem(groups, chosenIds) {
    for (const group of groups) {
        const inGroup = new Set(group.modifierIds);
        const chosen = chosenIds.filter((id) => inGroup.has(id)).length;
        const min = modifierGroupMinimum(group);
        const max = Math.max(group.maxChoices, min);
        if (chosen < min)
            return { groupId: group.id, groupName: group.name, kind: 'too-few', min, max, chosen };
        if (chosen > max)
            return { groupId: group.id, groupName: group.name, kind: 'too-many', min, max, chosen };
    }
    return null;
}
/** The order number as staff and players read it (spec/13 §6.2): `#0421`; `null` when there is none yet. */
export function formatOrderNumber(orderNumber) {
    if (orderNumber === null || orderNumber === undefined)
        return null;
    return `#${String(orderNumber).padStart(4, '0')}`;
}
//# sourceMappingURL=menu-choice.js.map